import _ from 'lodash'

const BUFFER_LENGTH_THRESHOLD = 6 //symbols
const DEBOUNCE_THRESHOLD = 50 //msec
const SCANNER_EVENT = 'keydown'
const ENTER_KEY = 'Enter'

export default {
  created: function () {
    let buffer = []
    let eventBuffer = []

    function checkBuffer() {
      const bufferLength = buffer.length
      if (bufferLength > BUFFER_LENGTH_THRESHOLD) {
        if (buffer[bufferLength - 1] === ENTER_KEY) {
          if (typeof this.handleCodeScanned === 'function') {
            this.handleCodeScanned(_.join(_.slice(buffer, 0, bufferLength - 1), ''))
          }
        }
        eventBuffer = []
      }
      buffer = []

      for (let event of eventBuffer) {
        if (event.key === 'Enter') {
          continue
        }

        let prevSymbol = event.target.value || ''
        event.target.value = prevSymbol + event.key

        let inputEvent = new Event('input', {
          'bubbles': true,
          'cancelable': true
        });

        event.target.dispatchEvent(inputEvent);
      }

      eventBuffer = []
    }

    const debouncedCheckBuffer = _.debounce(checkBuffer, DEBOUNCE_THRESHOLD)

    this.barcodeScannerHandler = (e) => {
      if (e.target.attributes['readonly']) {
        return true
      }

      //Если в текстовом поле и есть выделение, пропускаем
      if (e.target.type === 'text' || e.target.type === 'textarea') {
        if (e.target.value.length > 0) {
          return true
        }

        if (typeof window.getSelection === 'function' && window.getSelection().toString().length > 1) {
          return true
        }
      }

      if (e.which === 0 || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey
        || e.code === 'Escape' || e.code === 'Backspace' || e.code === 'CapsLock' || e.code === 'Tab' || (e.keyCode >= 37 && e.keyCode <= 40)
        || (e.keyCode >= 112 && e.keyCode <= 123)) {
        return true
      }

      buffer.push(e.key)
      eventBuffer.push(e)
      debouncedCheckBuffer.apply(this)
      e.preventDefault()
    }

    document.addEventListener(SCANNER_EVENT, this.barcodeScannerHandler);
  },
  destroyed() {
    document.removeEventListener(SCANNER_EVENT, this.barcodeScannerHandler)
  },
}
